import React, { useEffect, useState } from 'react';
import { Image, Navbar, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import {
  CAPTAIN_ROUTE,
  CHALLENGE_ROUTE,
  DASHBOARD_ROUTE,
  EVENT_ROUTE,
  GUARDIAN_SETTINGS_ROUTE,
  HOME_FEED,
  MULTI_LOGIN,
  MY_ROOM,
  MY_ROOM_ROUTE,
  NEXT_CHALLENGE_ROUTE,
  NOTIFICATION_ROUTE,
  SHARE_CREATION_ROUTE_BANNER,
  SPECIAL_CHALLENGE_ROUTE,
  TALETREE_MAP,
} from '../../constants/routes.constants';
import { useAuth } from '../auth/Auth';
import logo from '../../assets/logo/logo-53x53.svg';
import TaletreeHeader from './TaletreeHeader';
import ProfileMenu from './ProfileMenu';
import './css/camp.header.scss';
import Home from '../../assets/icon/header/Home.svg';
import HomeActive from '../../assets/icon/header/Home_active.svg';
import Challenge from '../../assets/icon/header/City.svg';
import ChallengeActive from '../../assets/icon/header/City_active.svg';
import Village from '../../assets/icon/header/Village.svg';
import VillageActive from '../../assets/icon/header/Village_active.svg';
import Log_Out from '../../assets/images/log-out.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { getUserNotificationChar } from '../../utils/camp.utils';
import Search from '../common/Search';
import Switch from 'react-switch';
import { changeBodyClassName } from '../../utils/utils';
import { bg } from '../../constants/component.constants';
import ImgMoon from '../../assets/icon/moon.svg';
import ImgSun from '../../assets/icon/sun.svg';
import MapMode from '../../assets/images/map-rocket.svg';
import MapModeHover from '../../assets/images/map-rocket-hover.svg';
import EventEmitter from '../../utils/events';
import { HOWS_YOUR_DAY } from '../../constants/companionPrompt.constants';
import CompanionPrompt from '../common/CompanionPrompt';
import KidsMoodModal from '../views/my_room/KidsMood';
import Creative_Gallery from '../../assets/images/New_Change_Img/Creative.svg';
import Emrald_img from '../../assets/images/New_Change_Img/Emrald.svg';
import Villageimg from '../../assets/images/New_Change_Img/Village.svg';
import { handleScrollToTop } from '../../utils/utils.js';
import { isMobile } from 'react-device-detect';
import { multiLoginViewModal } from '../views/multilogin/multilogin.view.model.js';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import SwitchUser from '../../assets/icon/header/SwitchUser.png';
import activeSwitchUser from '../../assets/icon/header/activeSwitchUser.png';
import { Box } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useHandleMultiLogin } from '../../utils/multilogin';

const CampHeader = ({
  isMyRoom = false,
  leftCollapsse = '',
  rightCollapsse = '',
}) => {
  const { logout, dependent, guardian, refreshUserState } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const mode = localStorage.getItem('mode');
  const [showMoodModal, setShowMoodModal] = useState(
    dependent?.profile?.taletree_friend &&
      dependent?.profile?.ask_for_mood &&
      localStorage.getItem('checkin_modal') === 'true'
  );

  const handleClick = () => {
    history.push(NOTIFICATION_ROUTE);
  };
  const [checked, setChecked] = useState(mode !== 'light');

  const handleChange = (val) => {
    setChecked(val);
    if (val) {
      changeBodyClassName([bg.DARK]);
      localStorage.setItem('mode', 'dark');
    } else {
      changeBodyClassName([bg.CHALLENGES]);
      localStorage.setItem('mode', 'light');
    }
  };

  useEffect(() => {
    handleChange(mode !== 'light');
    if (location?.state?.from === 'login') {
      // EventEmitter.dispatch('show_prompt', {
      //   showPrompt: 'block',
      //   promptType: HOWS_YOUR_DAY
      // })
    }
  }, []);

  const [isNavbarOpen, setIsNavbarOpen] = useState(false); // State to track if navbar is open

  const handleToggleClick = () => {
    setIsNavbarOpen(!isNavbarOpen); // Toggle navbar open state
  };

  useEffect(() => {
    if (isMobile) {
      if (
        leftCollapsse === 'left-collapsse' ||
        rightCollapsse === 'right-collapsse'
      ) {
        setIsNavbarOpen(true);
      } else {
        setIsNavbarOpen(false);
      }
    }
  }, [leftCollapsse, rightCollapsse]);

  const handleParentLogin = async () => {
    if (guardian?.id) {
      history.push(MULTI_LOGIN);
    } else {
      try {
        await multiLoginViewModal.multiLoginParent();
        localStorage.setItem('isGuardianFromBrowse', true);
        refreshUserState();
        history.push(MULTI_LOGIN);
      } catch (error) {
        console.log(error, 'error in  parent login ');
      }
    }
  };
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const { handleSwithChildToGuardian } = useHandleMultiLogin();
  return (
    <TaletreeHeader className="camp-header kid">
      <CompanionPrompt />
      {showMoodModal && (
        <KidsMoodModal
          showMoodModal={showMoodModal}
          setShowMoodModal={setShowMoodModal}
        />
      )}
      <div className="navbar-brand-wrapper">
        <LinkContainer to={HOME_FEED}>
          <Navbar.Brand>
            <Image src={logo} className="logo" />
          </Navbar.Brand>
        </LinkContainer>
        <div className="headerUserNotification">
          <Image
            onClick={dependent && handleClick}
            src={getUserNotificationChar(dependent)}
            className="User Avtar"
          />
        </div>
        {/* {(isNotificationVisible && dependent?.viewer === 'guardian') ||
        guardian?.viewer == 'guardian' ? (
          <div
            className="headerUserNotification"
            style={{ marginLeft: '0px !important' }}
            // onClick={handleClick}
            style={{ position: 'relative' }}
          >
            <span
              className="userNotification kid bb"
              style={{
                position: 'absolute',
                zIndex: 1,
                whiteSpace: 'nowrap',
                left: '96%',
                marginLeft: '0px !important',
                color: '#fff',
                display: 'flex',
              }}
            >
              Hey {dependent !== null && dependent.first_name}, I want to talk toyou.
              <div
                onClick={() => {
                  handleSwithChildToGuardian(
                    guardian?.id,
                    MULTI_LOGIN,
                    GUARDIAN_SETTINGS_ROUTE
                  );
                }}
              >
                <p style={{ margin: 0 }}>Return to your dashboard</p>
              </div>
              <HighlightOffIcon
                sx={{ ml: '8px' }}
                onClick={() => setIsNotificationVisible(false)}
              />
            </span>
          </div>
        ) : (
          ''
        )} */}
        <Box className="ccc">
          <Search />
        </Box>
      </div>
      {!isNavbarOpen && ( // Conditionally render based on navbar state
        <div className="mobile_marginTop">
          <div className="col-12 text-center" onClick={handleScrollToTop}>
            <Image
              className="centerimghader"
              src={
                history?.location?.pathname === HOME_FEED
                  ? Creative_Gallery
                  : history.location.pathname === NEXT_CHALLENGE_ROUTE
                  ? Emrald_img
                  : isMyRoom ||
                    history.location.pathname.slice(0, 8) === CAPTAIN_ROUTE
                  ? Villageimg
                  : ''
              }
              alt=""
            />
          </div>
        </div>
      )}
      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        onClick={handleToggleClick}
      />
      <Navbar.Collapse id="responsive-navbar-nav" className="">
        <Nav className=" align-items-md-center navbar-sub navbar-custom ">
          <LinkContainer to={HOME_FEED}>
            <Nav.Link
              className={`px-3 camp-header-link Home-feed-header ${
                history?.location?.pathname === HOME_FEED ? 'header-active' : ''
              }`}
            >
              <Image
                className="fit_size_img home-normal-state"
                src={
                  history?.location?.pathname === HOME_FEED ? HomeActive : Home
                }
                alt=""
              />
              <Image
                className="fit_size_img home-hover-state"
                src={HomeActive}
                alt=""
              />
              <span className="mob-menu">Creative Gallery</span>
            </Nav.Link>
          </LinkContainer>
          <LinkContainer to={NEXT_CHALLENGE_ROUTE}>
            <Nav.Link
              className={`px-3 camp-header-link City-header ${
                history.location.pathname.slice(0, 11) ===
                  NEXT_CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 10) === CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 18) ===
                  SPECIAL_CHALLENGE_ROUTE ||
                history.location.pathname.slice(0, 6) === EVENT_ROUTE
                  ? 'header-active'
                  : ''
              }`}
            >
              {history.location.pathname.slice(0, 11) ===
                NEXT_CHALLENGE_ROUTE ||
              history.location.pathname.slice(0, 10) === CHALLENGE_ROUTE ||
              history.location.pathname.slice(0, 18) ===
                SPECIAL_CHALLENGE_ROUTE ||
              history.location.pathname.slice(0, 6) === EVENT_ROUTE ? (
                <Image className="fit_size_img" src={ChallengeActive} alt="" />
              ) : (
                <>
                  <Image
                    className="fit_size_img city-normal-state"
                    src={Challenge}
                    alt=""
                  />
                  <Image
                    className="fit_size_img city-hover-state"
                    src={ChallengeActive}
                    alt=""
                  />
                </>
              )}
              <span className="mob-menu">Emerald City</span>
            </Nav.Link>
          </LinkContainer>
          <LinkContainer to={MY_ROOM_ROUTE}>
            <Nav.Link
              className={`px-3 camp-header-link Village-header ${
                history.location.pathname !== HOME_FEED &&
                history.location.pathname !== NEXT_CHALLENGE_ROUTE &&
                history.location.pathname.slice(0, 10) !== CHALLENGE_ROUTE &&
                history.location.pathname.slice(0, 18) !==
                  SPECIAL_CHALLENGE_ROUTE &&
                history.location.pathname.slice(0, 6) !== EVENT_ROUTE &&
                history.location.pathname.slice(0, 9) !==
                  SHARE_CREATION_ROUTE_BANNER &&
                history.location.pathname !== NOTIFICATION_ROUTE
                  ? 'header-active'
                  : ''
              }`}
            >
              {history.location.pathname !== HOME_FEED &&
              history.location.pathname !== NEXT_CHALLENGE_ROUTE &&
              history.location.pathname.slice(0, 10) !== CHALLENGE_ROUTE &&
              history.location.pathname.slice(0, 18) !==
                SPECIAL_CHALLENGE_ROUTE &&
              history.location.pathname.slice(0, 6) !== EVENT_ROUTE &&
              history.location.pathname.slice(0, 9) !==
                SHARE_CREATION_ROUTE_BANNER &&
              history.location.pathname !== NOTIFICATION_ROUTE ? (
                <Image className="fit_size_img" src={VillageActive} alt="" />
              ) : (
                <>
                  <Image
                    className="fit_size_img village-normal-state"
                    src={Village}
                    alt=""
                  />
                  <Image
                    className="fit_size_img village-hover-state"
                    src={VillageActive}
                    alt=""
                  />
                </>
              )}
              <span className="mob-menu">TaleTree Village</span>
            </Nav.Link>
          </LinkContainer>
          {dependent?.viewer === 'guardian' ||
          guardian?.viewer === 'guardian' ? (
            <Nav.Link
              onClick={() => handleParentLogin()}
              className="px-3 camp-header-link Home-feed-header mob-menu"
            >
              <Image
                className="fit_size_img"
                src={
                  history?.location?.pathname === HOME_FEED
                    ? SwitchUser
                    : activeSwitchUser
                }
                alt=""
                style={{
                  height: '40px',
                  paddingLeft: 0,
                }}
              />
              <span className="mob-menu">Switch Account</span>
            </Nav.Link>
          ) : (
            ''
          )}
          <div />
          <Nav.Link
            className="px-4 camp-header-link logout"
            onClick={() => logout()}
          >
            <Image
              className="fit_size_img city-hover-state"
              src={Log_Out}
              alt=""
            />
            <span className="mob-menu"> Logout</span>
          </Nav.Link>

          <div className="profile-menu-header-container">
            <div
              className="map-mode"
              onClick={() => history.push(TALETREE_MAP)}
            >
              <img className="normal-state" src={MapMode} alt="" />
              <img className="hover-state" src={MapModeHover} alt="" />
            </div>
            <label htmlFor="small-radius-switch">
              {/* <span>A switch all available styling options</span> */}
              <Switch
                checked={checked}
                onChange={handleChange}
                handleDiameter={28}
                offColor="#08f"
                onColor="#101B2F"
                offborder="2px solid #CCDCF3"
                // onBorder="2px solid #CCDCF3"
                height={50}
                width={120}
                borderRadius={150}
                activeBoxShadow="0px 0px 1px 2px #fffc35"
                uncheckedIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      fontSize: 9,
                      color: '#fff',
                      paddingRight: 2,
                      paddingLeft: 1,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Day Mode
                  </div>
                }
                checkedIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      fontSize: 9,
                      color: '#fff',
                      paddingRight: 2,
                      paddingLeft: 1,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Night Mode
                  </div>
                }
                uncheckedHandleIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <img src={ImgSun} />
                  </div>
                }
                checkedHandleIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <img src={ImgMoon} />
                  </div>
                }
                className="react-switch"
                id="small-radius-switch"
              />
            </label>
            <ProfileMenu />
          </div>
          <div className="mobile-search">
            <Search />
            <div className="mobile-bottom-wrapper">
              <div
                className="map-mode"
                onClick={() => history.push(TALETREE_MAP)}
              >
                <img className="normal-state" src={MapMode} alt="" />
                <img className="hover-state" src={MapModeHover} alt="" />
              </div>
              <label htmlFor="small-radius-switch">
                <Switch
                  checked={checked}
                  onChange={handleChange}
                  handleDiameter={28}
                  offColor="#08f"
                  onColor="#101B2F"
                  offborder="2px solid #CCDCF3"
                  // onBorder="2px solid #CCDCF3"
                  height={50}
                  width={120}
                  borderRadius={150}
                  activeBoxShadow="0px 0px 1px 2px #fffc35"
                  uncheckedIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        fontSize: 9,
                        color: '#fff',
                        paddingRight: 2,
                        paddingLeft: 1,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        fontFamily: 'Open Sans',
                      }}
                    >
                      Day Mode
                    </div>
                  }
                  checkedIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        fontSize: 9,
                        color: '#fff',
                        paddingRight: 2,
                        paddingLeft: 1,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        fontFamily: 'Open Sans',
                      }}
                    >
                      Night Mode
                    </div>
                  }
                  uncheckedHandleIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <img src={ImgSun} />
                    </div>
                  }
                  checkedHandleIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <img src={ImgMoon} />
                    </div>
                  }
                  className="react-switch"
                  id="small-radius-switch"
                />
              </label>
            </div>
          </div>
        </Nav>
      </Navbar.Collapse>
    </TaletreeHeader>
  );
};

export default CampHeader;
